import { Typography } from '@mui/material';
import { WhatIsPsychiatryList } from '../../assessment/icon-lists';

type WhatsPsychiatryProps = {
  color?: string;
};

export const WhatsPsychiatry = ({ color }: WhatsPsychiatryProps) => (
  <>
    <Typography sx={{ mb: 3 }} color={color}>
      Psychiatrists are doctors for your mental health. They can:
    </Typography>
    <WhatIsPsychiatryList />
  </>
);
